import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { supabase } from '../lib/supabaseClient';

function UpdatePassword() {
  const { updatePassword } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Ensure we are in a password recovery session
    (async () => {
      const { data } = await supabase.auth.getSession();
      const hasSession = Boolean(data?.session);
      if (!hasSession) {
        // If no session, try to exchange hash params automatically (Supabase v2 handles via reset link)
        // Otherwise, just render form and let updateUser fail gracefully.
      }
    })();
  }, []);

  const submit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setOk(false);
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setPending(true);
    try {
      const res = await updatePassword(password);
      if (!res.ok) throw new Error(res?.error?.message || 'Failed to update password');
      setOk(true);
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err.message || 'Error');
    } finally {
      setPending(false);
    }
  }, [password, confirm, updatePassword, navigate]);

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <h1 className="h3 mb-4">Set a new password</h1>
          {error && <Alert variant="danger">{error}</Alert>}
          {ok && <Alert variant="success">Password updated. Redirecting…</Alert>}
          <Form onSubmit={submit}>
            <Form.Group className="mb-3">
              <Form.Label>New password</Form.Label>
              <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm password</Form.Label>
              <Form.Control type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
            </Form.Group>
            <Button type="submit" variant="primary" disabled={pending}>Update password</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default UpdatePassword;



